import moment from 'moment';
import { EMARPOLDocuments } from '../../marpol/@types';
import { TBiofouling2Place } from '../@types';
import {
    EBFL2RecordCode,
    EBFL2RecordState,
    TBFL2CommonData,
    TBFL2CommonFields,
} from '../@types';

export type TBFL2F1Item1 = {
    locationWhereShipWasInspected: string;
};

export type TBFL2F1Item2 = {
    contingencyActions: string;
};

export type TBFL2F1Item3 = {
    dateWhenShipCompletedReactiveCleaning: string;
};

export type TBFL2F1 = TBFL2CommonFields &
    TBFL2CommonData & {
        id: string;
        recordCode: EBFL2RecordCode.BFL2F1;
        item1: TBFL2F1Item1;
        item2: TBFL2F1Item2;
        item3: TBFL2F1Item3;
    };

export type TBFL2F = TBFL2F1;

const BFL2F_DEFAULTS: {
    F1: TBFL2F1;
} = {
    F1: {
        id: '',
        _rev: '',
        marpolType: EMARPOLDocuments.BFL2,
        state: EBFL2RecordState.IDLE,
        selectedDate: moment().format('YYYY-MM-DD'),
        remarks: '',
        item1: {
            locationWhereShipWasInspected: '',
        },
        item2: {
            contingencyActions: '',
        },
        item3: {
            dateWhenShipCompletedReactiveCleaning: '',
        },
        recordCode: EBFL2RecordCode.BFL2F1,
    },
};

export { BFL2F_DEFAULTS };
